import { AttachmentIcon } from 'assets/icons/AttachmentIcon'
import { DeleteIcon } from 'assets/icons/DeleteIcon'
import styled from 'styled-components'
import { colors, Flex, Icon } from 'styling/GlobalStyles'
import { ColorVariant, SmallText } from 'styling/TypographyV2'
import { formatBytes } from 'utils/helpers'

export const UploadedFile = ({ file, iconBgImage }: { file: File; iconBgImage?: string }) => {
  return (
    <Container>
      <Flex gap='0.75rem' center>
        <FileIcon
          style={{
            backgroundImage: `url(${iconBgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          {iconBgImage ? null : <AttachmentIcon />}
        </FileIcon>
        <TextContainer>
          <SmallText>{file.name}</SmallText>
          <SmallText colorVariant={ColorVariant.SECONDARY}>{formatBytes(file.size)}</SmallText>
        </TextContainer>
      </Flex>
      <Icon fill={colors.red} size='1.25rem'>
        {DeleteIcon}
      </Icon>
    </Container>
  )
}

const Container = styled.div`
  padding: 0.75rem;
  border-radius: 12px;
  justify-content: space-between;

  display: flex;
  align-items: center;
  gap: 0.75rem;

  ${(props) => props.theme.boxContainer}
  border: 1px solid ${(props) => props.theme.tableRowBorder};
`

const FileIcon = styled.div`
  width: 40px;
  height: 40px;
  background-color: #4f4f4f;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.secondaryTextColor};
`
const TextContainer = styled.div`
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
